import { print } from "graphql";

import { graphql } from "lib/generated/app-service-gql";
import { DocumentFindLeadsUpdatesSubscription } from "lib/generated/app-service-gql/graphql";
import { useDocumentAiRunUpdates } from "./useDocumentAiRunUpdates";
import { documentFindLeadsCachedQueryKey } from "./useDocumentFindLeadsCached";

const documentFindLeadsUpdatesSubscriptionDoc = graphql(`
  subscription documentFindLeadsUpdates($operationId: String!) {
    documentFindLeadsUpdates(operationId: $operationId) {
      operationId
      status
    }
  }
`);

// codegen scans the template literal above for types; `useSubscription` needs the string form.
const documentFindLeadsUpdatesSubscriptionString = print(documentFindLeadsUpdatesSubscriptionDoc);

type Props = {
  documentId: string;
  operationId: string | null;
  enabled: boolean;
};

export function useDocumentFindLeadsUpdates({ documentId, operationId, enabled }: Props) {
  return useDocumentAiRunUpdates<DocumentFindLeadsUpdatesSubscription>({
    subscription: documentFindLeadsUpdatesSubscriptionString,
    operationId,
    enabled,
    queryKey: documentFindLeadsCachedQueryKey(documentId),
    getStatus: (data) => data.documentFindLeadsUpdates.status,
  });
}
